/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;
      let
        parent_section = slideshow.closest('.shopify-section'),
        dots = slideshow.dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        pageDots = slideshow.dataset.dots == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-custom-dots'),
        custom_navigation = slideshow.querySelector('.flickity-custom-navigation'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.documentElement.getAttribute('dir') === 'rtl' || window.location.pathname.toLowerCase().startsWith('/ar-sa'),
        cell_align = (align == 'left' && rightToLeft ? 'right' : 'left'),
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: cell_align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {}
        };
      this.paused = false;
      if (custom_dots) {
        args.pageDots = false;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--image')) {
        let image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow--image-media');

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content') ||
        slideshow.classList.contains('customer-reviews--content') ||
        slideshow.classList.contains('customer-reviews--image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.wrapAround = false;
        args.adaptiveHeight = false;
        args.resize = true;
        args.on.ready = function () {
          let flkty = this;
          flkty.resize();
          document.fonts.ready.then(function () {
            flkty.resize();
          });
        };
      }
      if (slideshow.classList.contains('collection-grid__carousel') || slideshow.classList.contains('dpt-related-pages__slider') || slideshow.classList.contains('dpt-collection-gallery__slider') || slideshow.classList.contains('dpt-collection-popular-products__slider') || slideshow.classList.contains('dpt-gallery__slider') || slideshow.classList.contains('dpt-product-recommendations__slider') || slideshow.classList.contains('product-recommendations__slider') || slideshow.classList.contains('dpt-explore-the-collection__slider') || slideshow.classList.contains('dpt-collections__slider') || slideshow.classList.contains('dpt-products__slider') || slideshow.classList.contains('dpt-product-variations__slider') || slideshow.classList.contains('dpt-products-push__slider') || slideshow.classList.contains('mobile-menu-promotions__slider')) {
        args.wrapAround = false;
      }
      if (slideshow.classList.contains('dpt-products-push__slider')) {
        args.draggable = true;
      }
      if (slideshow.classList.contains('mobile-menu-promotions__slider')) {
        args.adaptiveHeight = true;
        args.on = {
          ready: function () {
            let flkty = this;

            function resizeSlider() {
              flkty.resize();
              flkty.reloadCells();
            }

            resizeSlider();

            slideshow.querySelectorAll('img').forEach((img) => {
              if (!img.complete) {
                img.addEventListener('load', resizeSlider);
                img.addEventListener('error', resizeSlider);
              }
            });

            document.fonts.ready.then(resizeSlider);

            const toggleWrapper = slideshow.closest('.mobile-toggle-wrapper');
            if (toggleWrapper) {
              const observer = new MutationObserver(() => {
                if (toggleWrapper.classList.contains('active')) {
                  setTimeout(resizeSlider, 400);
                }
              });
              observer.observe(toggleWrapper, {
                attributes: true,
                attributeFilter: ['class']
              });
            }
          }
        };
      }

      const isSearchDrawerMenuCarousel =
        slideshow.classList.contains('search-drawer-iconics-carousel') ||
        slideshow.classList.contains('search-drawer-novelty-carousel');

      if (isSearchDrawerMenuCarousel) {
        args.wrapAround = false;
        args.adaptiveHeight = false;
        args.resize = true;
        const mobileMaxWidth = 767;
        let searchDrawerResizeTimeout;
        const searchDrawer = slideshow.closest('.search-drawer');

        function isMobileView() {
          return window.innerWidth < mobileMaxWidth;
        }

        function isDrawerOpen() {
          return searchDrawer && searchDrawer.classList.contains('active');
        }

        function setNavVisible(visible) {
          if (prev_button) {
            prev_button.style.display = visible ? '' : 'none';
          }
          if (next_button) {
            next_button.style.display = visible ? '' : 'none';
          }
        }

        function bindArrowNav(instance) {
          if (prev_button) {
            prev_button.onclick = (event) => {
              event.preventDefault();
              instance.previous();
            };
          }
          if (next_button) {
            next_button.onclick = (event) => {
              event.preventDefault();
              instance.next();
            };
          }
        }

        function measureSearchDrawerCarouselHeight(instance) {
          if (!instance || !instance.cells.length) {
            return 0;
          }

          let maxHeight = 0;

          instance.cells.forEach(function (cell) {
            if (cell.size && cell.size.outerHeight > maxHeight) {
              maxHeight = cell.size.outerHeight;
            }
          });

          if (maxHeight < 1) {
            instance.cells.forEach(function (cell) {
              const card = cell.element.querySelector('.search-drawer-iconics-card, .search-drawer-novelty-card');
              const target = card || cell.element;
              const height = target.getBoundingClientRect().height;
              if (height > maxHeight) {
                maxHeight = height;
              }
            });
          }

          return maxHeight;
        }

        function resizeSearchDrawerCarousel(instance) {
          if (!instance) {
            return;
          }

          instance.reloadCells();
          instance.resize();
          instance.updateSlides();

          const maxHeight = measureSearchDrawerCarouselHeight(instance);

          if (maxHeight > 0 && instance.viewport) {
            instance.viewport.style.height = maxHeight + 'px';
            slideshow.style.setProperty('--search-drawer-carousel-height', maxHeight + 'px');

            const collection = slideshow.closest('.iconics-collections, .novelty-collections');
            if (collection) {
              collection.style.minHeight = maxHeight + 48 + 'px';
            }
          }
        }

        function scheduleSearchDrawerCarouselResize() {
          const runResize = function () {
            resizeSearchDrawerCarousel(Flickity.data(slideshow));
          };
          [0, 50, 150, 300, 500, 750, 1000].forEach(function (delay) {
            setTimeout(runResize, delay);
          });
          slideshow.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
              img.addEventListener('load', runResize, { once: true });
              img.addEventListener('error', runResize, { once: true });
            }
          });
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(runResize);
          }
        }

        function enableGridLayout() {
          const existing = Flickity.data(slideshow);
          if (existing) {
            try {
              existing.destroy();
            } catch (e) {}
          }
          slideshow.classList.add('is-grid-layout');
          slideshow.classList.remove('is-search-drawer-slider-ready');
          slideshow.dataset.initiated = 'true';
          delete slideshow.dataset.searchDrawerSliderPending;
          setNavVisible(false);
        }

        function enableSliderLayout(forceInit) {
          slideshow.classList.remove('is-grid-layout');

          if (!forceInit && !isDrawerOpen()) {
            slideshow.dataset.searchDrawerSliderPending = 'true';
            setNavVisible(true);
            return;
          }

          delete slideshow.dataset.searchDrawerSliderPending;
          setNavVisible(true);

          let instance = Flickity.data(slideshow);
          if (!instance && typeof Flickity !== 'undefined') {
            args.on = {
              ready: function () {
                resizeSearchDrawerCarousel(this);
              },
              change: function () {
                selectedIndex = this.selectedIndex;
                resizeSearchDrawerCarousel(this);
              }
            };
            instance = new Flickity(slideshow, args);
            selectedIndex = instance.selectedIndex;
            slideshow.dataset.initiated = 'true';
            bindArrowNav(instance);
          } else if (instance) {
            bindArrowNav(instance);
          }

          slideshow.classList.add('is-search-drawer-slider-ready');
          scheduleSearchDrawerCarouselResize();
        }

        function updateLayout() {
          if (isMobileView()) {
            enableSliderLayout(false);
          } else {
            enableGridLayout();
          }
        }

        function onSearchDrawerOpen() {
          if (!isMobileView()) {
            return;
          }
          if (slideshow.dataset.searchDrawerSliderPending === 'true' || !Flickity.data(slideshow)) {
            enableSliderLayout(true);
          } else {
            scheduleSearchDrawerCarouselResize();
          }
        }

        updateLayout();

        window.addEventListener('resize', function () {
          clearTimeout(searchDrawerResizeTimeout);
          searchDrawerResizeTimeout = setTimeout(updateLayout, 150);
        });

        if (searchDrawer) {
          searchDrawer.addEventListener('search-drawer:open', onSearchDrawerOpen);

          const observer = new MutationObserver(function () {
            if (searchDrawer.classList.contains('active')) {
              onSearchDrawerOpen();
            }
          });
          observer.observe(searchDrawer, {
            attributes: true,
            attributeFilter: ['class']
          });
        }

        if (Shopify.designMode) {
          slideshow.addEventListener('shopify:block:select', function (event) {
            const flkty = Flickity.data(slideshow);
            if (!flkty) {
              return;
            }
            let index = slideshow_slides.indexOf(event.target);
            flkty.select(index);
          });
        }

        return;
      }
      // Main Slideshow
      if (slideshow.classList.contains('main-slideshow')) {

        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Transparent Header padding.
            if (header) {
              if (header.classList.contains('transparent--true')) {
                let sections = Array.from(document.querySelector('#main-content').querySelectorAll(':scope > .shopify-section')),
                  i = sections.indexOf(parent_section);

                if (i == 0 && slideshow.classList.contains('section-spacing--disable-top')) {
                  slideshow.classList.add('slideshow--top');
                }
              }
            }
            // Animations.
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // AutoPlay Progress
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.setupAutoplayProgress(slideshow);
            }

            // Fonts resize
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {

              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Animations.
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes.
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text');
            if (autoplay_progress && animations_enabled) {
              autoplay_progress.style.setProperty('--color-body', color_text);
            }
            let dots = slideshow.querySelector('.flickity-page-dots');
            if (dots) {
              dots.style.setProperty('--color-body', color_text);
            }

            // Custom Dots.
            if (custom_navigation) {
              custom_navigation.querySelector('.flickity-custom-navigation--current').innerHTML = this.selectedIndex + 1;
            }

            // AutoPlay Progress
            if (autoplay) {

              if (flkty.player.state !== 'paused') {
                flkty.stopPlayer();
                flkty.playPlayer();
              }
            }
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.autoPlayProgressTL.progress(0);

              if (flkty.player.state !== 'paused') {
                slideshow.autoPlayProgressTL.play();
              }
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }

      // Media with tabs
      if (slideshow.classList.contains('media-with-tabs--media')) {
        args.draggable = false;
        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              video_container.querySelector('video').onloadstart = function () {
                slideshow.videoPlay(video_container);
              };
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.media-with-tabs--media--video');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              slideshow.videoPlay(video_container);
            }
          }
        };
      }

      // Announcement bar color change
      if (slideshow.classList.contains('announcement-bar--use-colors-true')) {
        args.on.change = function (index) {
          const container = slideshow.closest('.announcement-bar');
          let color_text = this.selectedElement.dataset.color,
            color_bg = this.selectedElement.dataset.bg;

          container.style.setProperty('--color-announcement-bar-bg', color_bg);
          container.style.setProperty('--color-announcement-bar-text', color_text);
        };
      }

      // Product Carousels
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        const existingOnReady = args.on.ready;
        const existingOnResize = args.on.resize;

        if (!window.updateFlickityProgressBarVisibility) {
          window.updateFlickityProgressBarVisibility = function (slideshowEl) {
            const bar = slideshowEl.parentNode && slideshowEl.parentNode.querySelector('.flickity-progress--bar');
            const container = bar && bar.parentElement;
            if (!container) {
              return;
            }
            const instance = typeof Flickity !== 'undefined' ? Flickity.data(slideshowEl) : null;
            const scrollable = instance && instance.cells && instance.cells.length && instance.slideableWidth > instance.size.innerWidth + 1;
            container.style.display = scrollable ? '' : 'none';
            if (!scrollable && bar) {
              bar.style.width = '0%';
            }
          };
        }

        args.on.ready = function () {
          if (existingOnReady) {
            existingOnReady.call(this);
          }
          window.updateFlickityProgressBarVisibility(slideshow);
        };

        args.on.resize = function () {
          if (existingOnResize) {
            existingOnResize.call(this);
          }
          window.updateFlickityProgressBarVisibility(slideshow);
        };

        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';

          if (prev_button && progress == 0) {
            prev_button.setAttribute('disabled', true);
          } else if (next_button && progress == 1) {
            next_button.setAttribute('disabled', true);
          } else {
            if (next_button) next_button.removeAttribute('disabled');
            if (prev_button) prev_button.removeAttribute('disabled');
          }

        };
      }

      // Testimonials
      if (custom_dots) {
        args.on = {
          ready: function () {
            let flkty = this;

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', (e) => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          },
          change: function (index) {

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.classList.remove('is-selected');
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }
        };
      }

      // Customer reviews
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }

      // Initiate
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      slideshow.dataset.initiated = true;

      // Flickity binds only touchstart when ontouchstart exists, so mouse drag
      // fails on touch-capable desktops (common on Windows). Re-enable mousedown.
      if ('ontouchstart' in window && flkty.viewport) {
        flkty.viewport.addEventListener('mousedown', flkty);
      }

      if (progress_bar) {
        window.updateFlickityProgressBarVisibility(slideshow);

        let progressResizeTimeout;
        window.addEventListener('resize', function () {
          clearTimeout(progressResizeTimeout);
          progressResizeTimeout = setTimeout(function () {
            window.updateFlickityProgressBarVisibility(slideshow);
          }, 100);
        });
      }


      // Arrows
      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          flkty.next();
        });
      }

      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    setupAutoplayProgress(slideshow) {
      slideshow.autoPlayProgressTL = gsap.timeline({
        inherit: false
      });
      slideshow.autoPlayProgressTL
        .fromTo(slideshow.querySelector('.thb-slideshow-progress--svg circle'), {
          drawSVG: 0
        }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          ease: 'none',
          drawSVG: true
        });
      slideshow.addEventListener('mouseenter', function () {
        slideshow.autoPlayProgressTL.pause().progress(0);
      });
      slideshow.addEventListener('mouseleave', function () {
        slideshow.autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').pause();
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').play();
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        let splittext = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-child'
        });
        let mask = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-parent'
        });

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;


          animations[i] = tl;

          if (slideshow.dataset.transition == 'zoom') {
            tl
              .to(item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'), {
                duration: 1.5,
                scale: 1
              }, "start");
          }

          if (item.querySelector('.inline-badge')) {
            tl
              .fromTo(item.querySelector('.inline-badge'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.2;
          }
          if (item.querySelector('.subheading')) {
            tl
              .fromTo(item.querySelector('.subheading'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('.slideshow__slide-heading')) {
            let h1_duration = 1 + ((item.querySelectorAll('.slideshow__slide-heading .line-child').length - 1) * 0.1);
            tl

              .set(item.querySelectorAll('.slideshow__slide-heading'), {
                opacity: 1
              }, 0)
              .from(item.querySelectorAll('.slideshow__slide-heading .line-child'), {
                duration: h1_duration,
                yPercent: 120,
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p.split-text')) {

            let p_duration = 1 + ((item.querySelectorAll('p.split-text .line-child').length - 1) * 0.05);
            tl
              .set(item.querySelectorAll('p.split-text'), {
                opacity: 1
              }, 0)
              .from(item.querySelectorAll('p:not(.subheading) .line-child'), {
                duration: p_duration,
                yPercent: '120',
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button, .text-button')) {
            tl
              .fromTo(item.querySelectorAll('.button, .text-button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      let flkty = Flickity.data(slideshow),
        active_slide = flkty.selectedElement;
      document.fonts.ready.then(function () {
        animations[i].restart();
      });
    }
    animateReverse(i, slideshow, animations) {
      animations[i].reverse();
    }
    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.element.querySelector('.product-featured-image')) {
        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;
      } else if (first_cell.element.querySelector('.gallery--item')) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        if (first_cell.element.querySelector('.customer-reviews--product')) {
          image_height = flickity.cells[1].element.querySelector('.customer-reviews--product').clientHeight;
        }
      }
      if (image_height > 0) {
        flickity.cells.forEach((item, i) => {
          if (item.size.height > max_height) {
            max_height = item.size.height;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          prev_button.style.transform = 'translateY(' + difference + 'px)';
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }

    }
  }
  customElements.define('slide-show', SlideShow);
}
